import { createSlice } from '@reduxjs/toolkit';
import { fetchEducator, fetchEducatorByUrl } from './thunks/fetchEducatorThunk';


const educatorSlice = createSlice({
  name: 'educator',
  initialState: {
    data: null,
    error: null,
    loading: false,
  },
  reducers: {
    resetEducatorData: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEducator.pending, (state) => {
        state.loading = true;
        state.error = null
      })
      .addCase(fetchEducator.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchEducator.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetchEducatorByUrl
      .addCase(fetchEducatorByUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEducatorByUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchEducatorByUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetEducatorData } = educatorSlice.actions;
export default educatorSlice.reducer;
